<template>
    <div class="header">
        <div class="container">
            <img class="titleimg" src="https://img.yilieyun.cn/tenant-logo/48/2023/companyLogo_1204112135.png"/>
            <img class="menuicon" @click="openmenu" :src="img"/>
        </div>
        <div class="menulist" v-if="flagmenu">
            <ul>
                <li v-for="(item,index) in menulist" class="menuchild" :class="{'pro':index==1}" :key="index" @click="gotoclick(item.path)">
                    <span >{{item.name}}</span>
                    <div class="probox" v-show="index==1" @click="gotohandclick('1')">
                       RPO招聘管理系统
                    </div>
                    <div class="probox" v-show="index==1" @click="gotohandclick('2')">
                       外包管理系统
                    </div>
                    <div class="probox" v-show="index==1" @click="gotohandclick('3')">
                       HR招聘管理系统
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import { boo } from "../../../tool/apiboo";
export default {
    name:'headers',
    data(){
        return{
            flagmenu:false,
            img1:'https://img.yilieyun.com/oss/ylyh5officialWebimagese/yly_menu.png',
            img2:'https://img.yilieyun.com/oss/ylyh5officialWebimagese/yly_close.png',
            img:'https://img.yilieyun.com/oss/ylyh5officialWebimagese/yly_menu.png',
            menulist:[
                {
                    name:'首页',
                    path:'/home'
                },
                {
                    name:'产品',
                    path:''
                },
                // {
                //     name:'免费体验',
                //     path:'/apply'
                // },
                {
                    name:'公司介绍',
                    path:'/about'
                }
            ],
            routeData: {}
        }
    },
    mounted(){
        let utm_source = ''
        let utm_content = ''
        let u = ''
      const url = 'https://officialsiteapi' + boo()+'.yilieyun.com/siteapi/Apply/officialUrlClickNum';
        let query = this.$route.query
        if (Object.keys(query).length) {
        utm_source = query.utm_source
        utm_content = query.utm_content
        u = query.u
        let params = new FormData();
        params.append('utm_source', utm_source);
        params.append('utm_content', utm_content);
        params.append('u', u);
        this.$axios({
          url,
          method: 'post',
          data: params
        })
        console.log('sssssssssssssssssss');
      }
        if (Object.keys(this.$route.query).length) {
            this.routeData = this.$route.query
        }
    },
    methods:{
        openmenu(){
            this.flagmenu=!this.flagmenu;
            if(this.flagmenu){
                this.img=this.img2;
            }else{
                this.img=this.img1;
            }
        },
        gotoclick(path){
            if(path==''){
                return;
            }
           console.log(this.routeData);
           this.$router.push({path:path,query:this.routeData});
          // this.$router.push(path);
           this.flagmenu=false;
           this.img=this.img1;
        },
        gotohandclick(val){
            if(val=='1'){
                this.$router.push({path:'/projectrpo',query:this.routeData});
            }else if(val=='2'){
                this.$router.push({path:'/projectoutsource',query:this.routeData});
            }else if(val=='3'){
                this.$router.push({path:'/projecthr',query:this.routeData});
            }
            console.log(val,'@@@@');
            this.flagmenu=false;
            this.img=this.img1;
        }
    }
}
</script>
<style lang="less" scoped>
.header{
    position: relative;
    .container{
        position: fixed;
        width: 100%;
        height: .43rem;
        background: #E7EEF9;
        top: 0;
        z-index: 100;
        .titleimg{
            position: absolute;
            width: .94rem;
            height: .26rem;
            left: .12rem;
            top: .09rem;
        }
        .menuicon{
            position: absolute;
            width: .25rem;
            height: .25rem;
            top: 50%;
            transform: translateY(-50%);
            right: .13rem;
        }
    }
    .menulist{
        position:fixed;
        width: 100%;
        height: 2.13rem;
        z-index: 100;
        top: .43rem;
        .menuchild{
            width: 100%;
            height: .52rem;
            background: #ffffff;
            font-size: .14rem;
            color: #1D2754;
            line-height: .52rem;
            padding-left: .2rem;
            border-bottom: solid 1px #E6EAFA;
        }
        .pro{
            height: 1.66rem;
        }
        .probox{
            width: 100%;
            height: .32rem;
            line-height: .32rem;
            padding-left: .2rem;
            box-sizing: border-box;
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/views/header/index.vue